<template>
    <div class="row">
        <div class="col-4">
            <div class="member-title">{{ role === 'professional' ? 'Professionals' : 'Family & Friends' }}</div>
            <div class="member-subtitle">{{
                    role === 'professional'
                        ? 'Teachers and Support Workers who will have access to all MagnusCards and activity calendar.'
                        : 'Parents and Tutors who will have access to all MagnusCards and activity calendar.'
                }}
            </div>
        </div>
        <div class="col-8 card p-0" v-if="data && data.length > 0">
            <div class="card-body p-0">
                <template>
                    <div class="table-responsive">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Date added</th>
                                <th>Last activity</th>
                                <th width="116"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="user in data" v-bind:key="user.name">
                                <td>
                                    <user-avatar :user="user"
                                                 :subtitle="user.pivot.team_member_profession === 'admin' ? '' : user.pivot.team_member_profession"
                                                 :displayName="true">
                                    </user-avatar>
                                </td>
                                <td>
                                    {{ user.created_at | moment('DD MMM, YYYY') }}
                                </td>
                                <td>
                                    {{ user.created_at | moment('DD MMM, YYYY') }}
                                </td>
                                <td v-if="user.pivot.team_member_profession === 'admin'" style="white-space: nowrap; text-align: right">
                                    <div class="admin-caregiver-badge">{{user.pivot.team_member_profession}}</div>
                                </td>
                                <td v-else style="white-space: nowrap; text-align: right">
                                    <a class="me-2" href="#" @click="deleteTeamMember(user)">
                                        <inline-svg src="/assets/img/icons/trash-01.svg"></inline-svg>
                                    </a>
                                    <a href="#" @click="editTeamMember(user)">
                                        <inline-svg src="/assets/img/icons/edit-01.svg"></inline-svg>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </div>
            <div v-if="showAddBtn" class="card-footer d-flex justify-content-end">
                <btn v-if="role === 'professional'" class="btn-primary" @click="$emit('add-professional')">
                    Invite a Professional
                </btn>
                <btn v-else class="btn-primary" @click="$emit('add-caregiver')">Invite a Caregiver</btn>
            </div>
        </div>
        <div class="col-8 mb-4 d-flex flex-column align-items-center justify-content-center" v-else-if="data && !data.length">
            <inline-svg src="/assets/img/no-professionals.svg"></inline-svg>
            <div class="no-data-title mt-4 mb-4">No {{role === 'professional' ? 'Professionals' : 'Caregivers' }} on your team yet</div>
            <btn v-if="role === 'professional'" class="btn-primary" @click="$emit('add-professional')">
                Invite a Professional
            </btn>
            <btn v-else class="btn-primary" @click="$emit('add-caregiver')">Invite a Caregiver</btn>
        </div>

    </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar.vue";

export default {
    name: 'TeamTable',
    props: ['value', 'role', 'showAddBtn', 'data'],
    components: {UserAvatar},
    mounted() {
    },
    data() {
        return {
            loading: {
                delete: false,
            },
            options: [],
        };
    },
    methods: {
        editTeamMember(user) {
            user.role = user.pivot.team_member_role;
            user.profession = user.pivot.team_member_profession;
            this.$emit('edit-team-member', user)
        },
        deleteTeamMember(user) {
            const self = this;
            this.$dialog.confirm('Are you sure you want to delete team member?', {
                okText: 'Yes',
                cancelText: 'No',
            }).then(() => {
                self.loading.delete = true;
                self.$http.post("/hero/delete-team-member", {hero_id: self.$route.params.hero_id, member_id: user.id, current_date: new Date()})
                    .then(() => {
                        self.$events.emit('loadTeamMembers');
                        self.loading.delete = false;
                    })
                    .catch(() => {
                        self.loading.delete = false;
                    });
            });
        },
    },
};
</script>
